<template>
<div class="min-h-screen">
  <div class="pagination-bg pagination-bg-sm pagination-bg-lg pagination-bg-2xl bg-center">
    <div class="max-w-7xl mx-auto pt-16 sm:pt-20">
    <div class="flex justify-center">
      <img src="@/assets/introduction.svg" class="sm:w-16 sm:h-16" alt="標本館介紹"/>
      </div>
    <h1 class="text-3xl sm:text-4xl font-black mt-5">標本館介紹</h1>
    </div>
  </div>
  <div class="max-w-7xl mx-auto mt-10 pb-20 px-10">
    <div class="flex space-x-5 justify-start">
      <router-link to="/">
      <a class="font-bold text-lg">首頁</a>
      </router-link>
      <p class="text-lg">></p>
      <p class="text-lg text-color-blue font-bold text-left">標本館介紹</p>
    </div>
    <div class="mt-20 text-lg" v-html="content"></div>
    <div class="hidden sm:block">
    <div class="flex justify-end mt-5 mr-5">
    <img src="@/assets/introduction-pic.png" alt="introduction image" class="introduction-pic test-pic"/>
    </div>
    </div>
  </div>
</div>
  <div class="footer-bg"></div>
</template>

<script>
import { getIntroduction } from '@/api/introductions'

export default {
  name: "Introduction Detail",
  title: '標本館介紹-TAIE',
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    getIntroduction(300).then(
      (response) => {
        this.content = response.data.content
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};
</script>

<style scoped>
@media (min-width: 1536px) {
  .pagination-bg-2xl {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1536.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .pagination-bg-lg {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1024.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .pagination-bg-sm {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over640.jpg");
  }
}

@media (max-width: 639.98px) {
  .pagination-bg {
    width: 100%;
    height: 250px;
    background-image: url("../../assets/pagination-bg-under640.jpg");
  }
}

a:hover {
color:#64859D;
}

.text-color-blue {
  color: #64859D;
}

.introduction-pic {
  width: 230px;
  height: 200px;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg.svg");
}
</style>
